import { createContext } from 'react';

const defaultState = { requiresProject: true, useVippsBranding: false };

const PaymentContext = createContext(defaultState);

export default PaymentContext;
